/**
 * affiliateTracker.js
 *
 * Drop this file anywhere in your src/ (e.g. src/utils/affiliateTracker.js)
 * and import { initAffiliateTracking, getStoredAffiliateId, clearAffiliateId }
 * wherever needed.
 *
 * Storage strategy:
 *   - localStorage  → survives page reloads, tab closes, and navigation
 *   - 7-day expiry  → clears stale tracking automatically
 */

const STORAGE_KEY = 'qm_affiliate_id';
const STORAGE_TS_KEY = 'qm_affiliate_ts';
const TTL_MS = 7 * 24 * 60 * 60 * 1000; // 7 days

/**
 * Call this as early as possible – ideally in App.js useEffect or
 * at the top of HomePage.js.
 * Reads ?t= from the URL, validates it, and persists it.
 */
export function initAffiliateTracking() {
  try {
    const params = new URLSearchParams(window.location.search);
    const raw = (params.get('t') || '').trim().toUpperCase();

    if (raw && /^[A-Z0-9]{12}$/.test(raw)) {
      localStorage.setItem(STORAGE_KEY, raw);
      localStorage.setItem(STORAGE_TS_KEY, Date.now().toString());

      // Clean the URL so the param doesn't stay visible
      const cleanUrl =
        window.location.pathname +
        (window.location.hash || '');
      window.history.replaceState({}, '', cleanUrl);

      console.debug('[affiliate] Tracked:', raw);
    }
  } catch (e) {
    // localStorage unavailable (private mode etc.) – fail silently
  }
}

/**
 * Returns the stored affiliate ID if it's still within TTL, or null.
 * Always call this just before posting to /api/user-results.
 */
export function getStoredAffiliateId() {
  try {
    const id = localStorage.getItem(STORAGE_KEY);
    const ts = parseInt(localStorage.getItem(STORAGE_TS_KEY) || '0', 10);

    if (!id) return null;

    // Expire after TTL
    if (Date.now() - ts > TTL_MS) {
      clearAffiliateId();
      return null;
    }

    return id;
  } catch (e) {
    return null;
  }
}

/**
 * Clear after a confirmed purchase so the same affiliate doesn't
 * get credited again on a second quiz by the same user.
 */
export function clearAffiliateId() {
  try {
    localStorage.removeItem(STORAGE_KEY);
    localStorage.removeItem(STORAGE_TS_KEY);
  } catch (e) {}
}